module.exports = __webpack_public_path__ + "img/featured-preview.c322a71e.png";